/* 3.8 · Валидация на българския телефонен формат.
   Тази форма е ЗАЯВКА, не поръчка. Ако някога добавиш сигнал към пиксел,
   прати Lead — никога Purchase. Иначе оптимизацията на рекламите се трови
   с фалшиви продажби. */
(function () {
  'use strict';

  // Приема: 08XXXXXXXX, +3598XXXXXXXX, 003598XXXXXXXX, със и без интервали и тирета.
  var BG_MOBILE = /^(?:\+359|00359|0)8[7-9]\d{7}$/;
  // Стационарни: 02XXXXXXX, 0XX XXXXXX и подобни.
  var BG_FIXED = /^(?:\+359|00359|0)[2-9]\d{6,8}$/;

  function normalise(value) {
    return value.replace(/[\s\-().]/g, '');
  }

  function isValid(value) {
    var v = normalise(value);
    return BG_MOBILE.test(v) || BG_FIXED.test(v);
  }


  /* Копие на заявката към Google Sheets.

     Праща се към Google форма, чиито отговори са свързани с таблица.
     Прави се "на сляпо" (no-cors) — Google не връща отговор, който да
     четем, но записът минава. Ако нещо се обърка, мълчим: имейлът от
     Shopify тръгва независимо и заявката не се губи. */
  /* Копие на заявката към Google Sheets.

     Работи по два начина според това какво е зададено в секцията:
       · адрес на Apps Script (/exec) — полетата се казват name и phone;
       · адрес на Google форма (/viewform) — ползват се entry ID-тата.

     Праща се "на сляпо" (no-cors) — Google не връща отговор, който да
     четем, но записът минава. Ако нещо се обърка, мълчим: имейлът от
     Shopify тръгва независимо и заявката не се губи. */
  function sendToSheet(form) {
    var section = form.closest('.lp-phone');
    if (!section) return;

    var url = section.getAttribute('data-lp-sheet-url');
    if (!url) return;

    var nameKey = section.getAttribute('data-lp-sheet-name') || 'name';
    var phoneKey = section.getAttribute('data-lp-sheet-phone') || 'phone';

    var name = form.querySelector('[name="contact[name]"]');
    var phone = form.querySelector('[name="contact[phone]"]');
    if (!name || !phone) return;

    var body = new FormData();
    body.append(nameKey, name.value.trim());
    body.append(phoneKey, phone.value.trim());
    body.append('page', location.pathname + location.search);

    var target = url.replace('/viewform', '/formResponse');

    /* sendBeacon оцелява, когато страницата се презарежда веднага след
       изпращането — обикновен fetch се отменя и редът никога не стига. */
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(target, body)) return;
    } catch (err) { /* пробваме резервния път */ }

    try {
      fetch(target, { method: 'POST', mode: 'no-cors', keepalive: true, body: body });
    } catch (err) { /* заявката към Shopify продължава без прекъсване */ }
  }


  /* Отчитане на заявката като Purchase.

     Собственикът настоява заявката с телефон да се отчита като Purchase,
     защото тук поръчката се потвърждава по телефона, а не в чекаута.
     Стойността се чете от data-lp-lead-value (по подразбиране 14.99).

     Внимание: това е поръчка НЕПОТВЪРДЕНА — част от хората отказват
     при обаждането. Meta ще брои и тях като продажби; истинската
     конверсия ще изглежда по-висока, отколкото е.

     Ако човекът е отказал бисквитки, fbq изобщо не съществува и тук
     не се случва нищо — така си и трябва. */
  function trackLead(form) {
    var value = parseFloat(form.getAttribute('data-lp-lead-value') || '14.99');
    var payload = {
      content_name: 'Бърза поръчка по телефон',
      content_type: 'product',
      value: value,
      currency: 'EUR'
    };

    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Purchase', payload);
      }
    } catch (err) { /* отчитането никога не бива да спира заявката */ }

    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('phone_order_submitted', { source: 'phone_order_form', value: value });
      }
    } catch (err) { /* същото */ }
  }

  function initForm(form) {
    if (form.dataset.lpPhoneOn === '1') return;
    form.dataset.lpPhoneOn = '1';

    /* Записът в таблицата се закача последен, за да е след проверката на
       номера. Ако тя е спряла изпращането, не записваме нищо.

       Спираме и самото Shopify изпращане — то е бавно (пренасочва към
       /contact#…) и оставя човека без обратна връзка. Вместо това
       показваме съобщение веднага, а редът пак стига до таблицата
       чрез sendBeacon. */
    function attachSheet() {
      form.addEventListener('submit', function (e) {
        if (e.defaultPrevented) return;
        e.preventDefault();
        sendToSheet(form);
        trackLead(form);
        showThanks(form);
      });
    }

    /* Заменя формата с благодарствено съобщение и зелено тикче. */
    function showThanks(form) {
      var section = form.closest('.lp-phone') || form.parentNode;
      var box = document.createElement('div');
      box.className = 'lp-phone__thanks';
      box.setAttribute('role', 'status');
      box.setAttribute('aria-live', 'polite');
      box.innerHTML =
        '<span class="lp-phone__tick" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="44" height="44" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">' +
            '<circle cx="12" cy="12" r="11" fill="#e8f7ec" stroke="#1f9d55"></circle>' +
            '<path d="M7 12.5l3.2 3.2L17 8.8" stroke="#1f9d55"></path>' +
          '</svg>' +
        '</span>' +
        '<p class="lp-phone__thanks-text">Благодарим за направената заявка, ще се свържем с вас <strong>СКОРО!</strong></p>';
      form.hidden = true;
      form.parentNode.insertBefore(box, form.nextSibling);
      // Скролваме, за да е видимо съобщението.
      try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }

    var input = form.querySelector('[data-lp-phone]');
    if (!input) { attachSheet(); return; }

    var err = form.querySelector('.lp-phone__inline-err');

    function show(bad) {
      if (err) err.hidden = !bad;
      input.setAttribute('aria-invalid', bad ? 'true' : 'false');
      input.classList.toggle('is-invalid', bad);
    }

    // Проверката е при напускане на полето, не при всеки натиснат клавиш —
    // иначе номерът е "грешен", докато човекът още го пише.
    input.addEventListener('blur', function () {
      if (input.value.trim() === '') { show(false); return; }
      show(!isValid(input.value));
    });

    input.addEventListener('input', function () {
      if (input.classList.contains('is-invalid') && isValid(input.value)) show(false);
    });

    form.addEventListener('submit', function (e) {
      if (!isValid(input.value)) {
        e.preventDefault();
        show(true);
        input.focus();
        return;
      }
      input.value = normalise(input.value);
    });

    attachSheet();
  }

  function initAll(root) {
    var forms = (root || document).querySelectorAll('.lp-phone__form');
    Array.prototype.forEach.call(forms, initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
